import { gql } from "@apollo/client";

// List Queries

export const GetCustomers = gql`
  query GetCustomers(
    $token: String!
    $after: Cursor
    $first: Int
    $orderBy: MstCustomerOrder
    $name: String
  ) {
    GetCustomers(
      token: $token
      after: $after
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          address
          place
          state
          pin
          country
          contactPerson
          contactPersonDesign
          email
          mobile
          url
          banner1
          banner2
          logoFilename
          isActive
          panNo
          gstNo
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

//By Ids

export const GetCustomerByNodeId = gql`
  query GetCustomerByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on MstCustomer {
        name
        address
        place
        state
        pin
        country
        contactPerson
        contactPersonDesign
        email
        mobile
        url
        banner1
        banner2
        logoFilename
        isActive
        panNo
        gstNo
      }
    }
  }
`;
